import storage from "@/utils/storage";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";

const useURLChecker = () => {
    const path = useLocation().pathname;

    const profilePage = /^\/profile$/;
    const supportPage = /^\/support$/;

    const { bid, oid } = useParams();

    useEffect(() => {
        if (!bid) {
            storage.removeItem("bid");
        }
        if (!oid && !profilePage.test(path) && !supportPage.test(path)) {
            storage.removeItem("oid");
        }
    }, [path]);
};

export default useURLChecker;
